export const theme_ns: ThemeNS = 'ainoa2024';